import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Spinner } from '@fluentui/react-components'

// Each surface is its own chunk. /config never loads Fluid; /side-panel and /stage
// pull the collab code only when they mount (and the side panel defers Fluid further --
// see AgentPanel). Keeps the heavy Fluid/Live Share stack out of the initial download.
const ConfigPage = lazy(() =>
  import('./features/meeting/ConfigPage').then((m) => ({ default: m.ConfigPage })),
)
const SidePanel = lazy(() =>
  import('./features/meeting/SidePanel').then((m) => ({ default: m.SidePanel })),
)
const Stage = lazy(() => import('./features/meeting/Stage').then((m) => ({ default: m.Stage })))

export function App() {
  return (
    <Suspense
      fallback={
        <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
          <Spinner />
        </div>
      }
    >
      <Routes>
        <Route path="/config" element={<ConfigPage />} />
        <Route path="/side-panel" element={<SidePanel />} />
        <Route path="/stage" element={<Stage />} />
        <Route path="/" element={<Navigate to="/side-panel" replace />} />
      </Routes>
    </Suspense>
  )
}
